
import * as Constants from './Constants';
import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import { getIntendType } from '../../components/common/Helpers/index';

export const getValidateOrder = (data) => ({
  type: Constants.GET_VALIDATEORDER,
  data,
});

export const updateCreditHoldTimerDetails = (update) => ({
  type: Constants.CREDIT_HOLD_STATUS,
  data: update,
});

export const landedStatusPage = (data) => ({
  type: Constants.TRIGGER_CREDIT_STATUS_LANDED,
  data,
});

export const resetOrderStatus = (data) => ({
  type: Constants.RESET_ORDER_STATUS,
  data,
});

export const reSubmitCreditReview = (data) => ({
  type: 'RESUMBIT_CREDIT_REVIEW',
  data,
});

export const reSubmitCreditReviewApi = (custData) => {
  const intendTypeval = getIntendType();

  const postData = {
    serviceHeader: {
      clientId: 'VZW-ECOM',
      statusMsg: 'PEGAgeneratedmessage',
      correlationId: '69a66ef4d7e344dfb2db299209ea8333',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            customerType: 'N',
          },

          cartInfo: {

            itemType: 'CREDITCHECK',
            intendType: intendTypeval,
            action: 'UPDATE',
            contactDetails: {
              firstName: custData.fName,
              lastName: custData.lName,
              contactNumber: custData.phoneNumber,
              address: {
                addressLine1: custData.address,
                addressLine2: custData.line2,
                zipCode: custData.zipCode,
                city: custData.city,
                state: custData.state,
                county: '',
              },
            },
            ssn: custData.ssn,
            dob: custData.dob,
            iwvSkipCreditCheck: false,
            skipByodCreditCheck: false,
            resubmitCredit: true,
            accountPin: custData.accountPin ? custData.accountPin : '',
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: intendTypeval,
            processStep: 'ShoppingCart',
            processAction: 'initiateCreditCheck',
          },
        },
      },
    },
  };
  return HttpService.post(
    `${getSecureBaseUrl()}${  apiUrls().reSubmitCredit}`, postData
  );
};

export const updateCreditCheckSuccess = (data) => ({
  type: 'UPDATE_CREDIT_REVIEW',
  data,
});
